__webpack_require__.p = "https://portfoliosai.link/sydneykart/";